import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { matchOtherValidator } from 'src/app/utils/validators/match-other-validator';
import { UsuarioGeneratePassComponent } from '../usuario-generate-pass/usuario-generate-pass.component';
import { UsuarioService } from '../usuario.service';
import { rutClean, rutFormat, RutValidator } from 'src/app/utils/rut.directive';

@Component({
  selector: 'app-usuario-view',
  templateUrl: './usuario-view.component.html',
  styleUrls: ['./usuario-view.component.scss']
})
export class UsuarioViewComponent implements OnInit {

  @Input() element: any;
  form: FormGroup = new FormGroup({});

  constructor(
    public formBuilder: FormBuilder,
    public activeModal: NgbActiveModal,
    public service: UsuarioService,
    public formatter: FormatterService,
    private modalService: NgbModal,
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      id: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      nombre: ['', [Validators.required]],
      apellido: ['', [Validators.required]],
      rut: ['Sin información', []],
      fono: ['Sin información'],
      password: ['', [Validators.required]],
      repeatPass: ['', [Validators.required, matchOtherValidator('password')]],
      rol_id: ['', [Validators.required]],
    });

    this.form.patchValue(this.element);
    if(this.element.rut) {
      this.form.patchValue({rut: rutFormat(this.form.value.rut)});
    }
    this.form.disable();
  }

  generatePass(): void {
    const modalRef = this.modalService.open(UsuarioGeneratePassComponent, { size: 'sm', centered: true });
    modalRef.result.then((result) => {
      this.form.patchValue({ password: result, repeatPass: result });
    }, (reason) => { });
  }
}